"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeNcoJson = void 0;
exports.normalizeNcoJson = (ncoJson) => {
    const dimensionsKeys = Object.keys(ncoJson.dimensions);
    const variableKeys = Object.keys(ncoJson.variables);
    const dimensions = dimensionsKeys.map((key) => ({ ...ncoJson.variables[key], key }));
    const variables = variableKeys.filter((key) => !dimensionsKeys.includes(key)).map((key) => ({ ...ncoJson.variables[key], key }));
    return {
        dimensions,
        variables,
    };
};
